import { Inject, Injectable } from '@angular/core';
import { FormControlStatus, FormGroup } from '@angular/forms';
import { BaseFpxComponentState, BaseFpxFormHelper, BaseFpxPostSubmitInterceptor, HttpProviderService, IHttpSuccessPayload, RoutingInfo } from "@fpx/core";
import {
  BaseFpxChangeHandler,
  BaseFpxEventHandler,
  BaseFpxLoadFormHandler,
  CriteriaQuery,
  FindByKeyFn,
  HttpRequest,
} from '@fpx/core';
import { VerifyotpService } from '../verifyotp-service/verifyotp.service';
import { Verifyotp } from '../verifyotp-service/verifyotp.model';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';
import { Observable, Subject, map } from 'rxjs';
import { UserService } from 'src/app/user.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PopupService } from 'src/app/common/services/popup/popup.service';
import { CommonService } from 'src/app/common.service';
import { ResponsiveService } from 'src/app/responsive.service';
import { element } from 'protractor';
import { CBXDialogData } from 'src/app/fpx-core/services/dialog/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorAlertComponent } from '../error-alert/error-alert.component';
import { Router } from '@angular/router';
import { RcobService } from '../services/rcob.service';
import { ApplPendencyService } from '../applPendency-service/applPendency.service';
import { ApplicationstatusService } from '../applicationstatus-service/applicationstatus.service';
import { AlertDialogComponent } from 'src/app/fpx-core/dialogs/alert-dialog/alert-dialog.component';
import { Data } from 'src/app/DataService';
import { log } from 'console';




export class COBVerifyOtpFormState extends BaseFpxComponentState {
  showSuggestion: boolean = false;
  doStartTimer: Subject<void> = new Subject();
  timerCount: number = 240;
  pinLength: number = 6;
  email: string;
  mobile: string;
  payload: any;
  error:any;
}


@Injectable()
export class COBVerifyOtpFormHelper extends BaseFpxFormHelper<COBVerifyOtpFormState>{
  stateCode: string;
  mode: string;
  isFormSubmitted:boolean = false;
  diableResendBtn:boolean = true;
  resendAttemptCount: number = 0;
  hideTimer: boolean;

  constructor(
    private cOBVerifyOtpFormService: VerifyotpService,
    private _processShellService: ProcessShellService,
    public verifyotpService: VerifyotpService,
    private _httpProvider:HttpProviderService,
    private _userService: UserService,
    @Inject(MAT_DIALOG_DATA) protected dialogData: any,
    private _popupService:PopupService,
    private _commonService: CommonService,
    protected translate: TranslateService,
    public responsive:ResponsiveService,
    private _dialog:MatDialog,
    private _router:Router,
    private _rocbService: RcobService,
    private _applPendencyService: ApplPendencyService,
    private applicationStatusService: ApplicationstatusService,
    private _dataStore: Data) {
    super(new COBVerifyOtpFormState());
  }

  override doPreInit(): void {
    if (this.getFormMode() === "ADD") {
      this.formGroup.removeControl('appRef');
    }
    // this._processShellService.setBackbtnVisible(false);
    let responseData;
    if(this.dialogData?.routingParams){
      this.stateCode = this.dialogData?.routingParams?.stageCode;
      this.mode = this.dialogData?.routingParams?.mode;
      responseData = this.dialogData?.routingParams?.response;
      sessionStorage.setItem('emailId',responseData.email);
      this.state.email = responseData.email;
      this.state.mobile = responseData.mobile;
    } else {
      this.stateCode = this.getRoutingParam('stageCode') ? this.getRoutingParam('stageCode') : 'ContactInfo';
      this.mode = this.getRoutingParam('mode');
      responseData = this.getRoutingParam('response');
      this.state.email = responseData.email;
      this.state.mobile = responseData.mobile;
    }
  }
  public doPostInit(): void {
    this.state.doStartTimer.next();
  }

  public doDestroy(): void {
    this.resendAttemptCount = 0;
    this._rocbService.checkResendAttempt = false;
  }

  closeAlert(action: string = ''){
    this._popupService.getModelInstance().close({
      result: action?action:'close'
    });
  }
  public override preSubmitInterceptor(payload: Verifyotp): any {
    this._commonService.showSpinner();
    this.isFormSubmitted = true;
    // WRITE CODE HERE TO HANDLE
    payload = {
      ...payload,
      'processCode': this._processShellService.processCode,
      'sourceReference': this._processShellService.processId,
      'mode': this.mode || 'E',
      'stageCode': this.stateCode
    }
    this.state.payload = payload;
    return payload;
  }

  public override postSubmitInterceptor(response: any): RoutingInfo {
    this._commonService.hideSpinner();

    let routingInfo: RoutingInfo = new RoutingInfo();
    // WRITE CODE HERE TO HANDLE
    let res = response?.success?.body;

    let err=response?.error?.error; 
    //complete the error handling code here


    // this.state.error=err?.ErrorDescription; //old implementation

    //new
    const specificErrorCodes = [
  "CBXRER026", "CBXRER035", "CBXRER005", "CBXRER006", "CBXRER007", "CBXRER008",
  "CBXRER012", "CBXRER013", "CBXRER014", "CBXRER015", "CBXRER016", "CBXRER017",
  "CBXRER018", "HTTP-413", "HTTP-414", "CBXRER004", "CBXRER001", "CBXRER002",
  "CBXRER019", "CBXRER020", "CBXRER021", "CBXRER022", "CBXRER009", "CBXRER010",
  "CBXRER011", "CBXRER032", "CBXRER031", "CBXRER029", "CBXRER030", "CBXRER033",
  "OBERR003", "ERROB003", "ERROB004", "ERROB011", "CBXRER036", "ERROB013",
  "CBXRER037", "CBXRER034", "ERROB005", "ERROB014", "ERROB015", "ERROB016",
  "ERRDEDUPE01", "ERROB012", "OBERR011", "CBXRER027", "CBXRER003"
];

// let err=response?.error?.error;
let errCode = response?.error?.error?.ErrorCode; 
let errDesc = response?.error?.error?.ErrorDescription;

if (specificErrorCodes.includes(errCode)) {
 
    this.state.error = errDesc;
} else {

    this.state.error = "Service Temporarily Unavailable. We’ve encountered an unexpected issue while processing your application. Please try again later.";

}

if (errCode==='CBXRERR005'){
  errCode='CBXRER005';
  this.state.error = "Invalid OTP";
  
}

//new end

    
    if(res?.processOverride && res?.processId && res?.processCode) {
      this._processShellService.setProcessCode(res.processCode);
      this._processShellService.setProcessId(res.processId);
    }

    if (res?.accessToken) {
        this._processShellService.hiddenProcessCode = res.processCode;
      // res.refreshToken = res?.accessToken;
      if(this._processShellService.getApplicationMode() != 'RM') this._userService.setToken(res);

      let decodesAccessToken = this._userService.decodeJwt(res?.accessToken);
      sessionStorage.setItem('customerName',decodesAccessToken.nickname);

      this._processShellService.prepareARN(res);
      this.proceedNext(res);
    }
    else if (response?.error?.error?.ErrorCode == 'ERROB015') {
      this._popupService.getModelInstance().close(response);
      routingInfo.setNavigationURL('onboarding/process-shell/rcob/result-info');
      routingInfo.setQueryParams({'res': 'rejected'})
    }
    else if(response?.error?.error?.ErrorCode == "CBXRER035"){
      this.formGroup.get("otp").reset();
      this.formGroup.get("otp").markAsTouched();
      // this.formGroup.get("otp").setErrors({expired:true}, { emitEvent: true });
      this.isFormSubmitted = false;
    }
    else if(response?.error?.error?.ErrorCode == "CBXRER004"){
      this.formGroup.get("otp").reset();
      this.formGroup.get("otp").markAsTouched();
      // this.formGroup.get("otp").setErrors({invalid:true}, { emitEvent: true });
      this.isFormSubmitted = false;
    }
    else if(err){
      this.formGroup.get("otp").reset();
      this.formGroup.get("otp").markAsTouched();
      // this.formGroup.get("otp").setErrors({error:true}, { emitEvent: true });

      this.isFormSubmitted = false;
    }
    else if(response?.success?.status == 200){
      this.proceedNext(res);
    }
    else {
      this.isFormSubmitted = false;
    }
    return routingInfo;
  }
  onTimeout() {
    // console.log("onTimeout: " + this.resendAttemptCount + " : " + this._rocbService.checkResendAttempt);
    if(this.resendAttemptCount >= 3 && this._rocbService.checkResendAttempt) {
      this.hideTimer = true;
      this.resendOTP();
    }
    else this.diableResendBtn =false;
    // this.formGroup.get("otp").setErrors({expired:true}, { emitEvent: true });
    this.formGroup.get("otp").reset();
    this.state.error='OTP expired';
    this.formGroup.get("otp").markAsTouched();
    console.log("On timer expire");
  }
  resendOTP() {
    ++this.resendAttemptCount;
    this.diableResendBtn=true;
    this.formGroup.get('otp').reset();
    this.state.doStartTimer.next();
    // this.formGroup.get("otp").setErrors(null, { emitEvent: false });
    this.state.error='';
    this.isFormSubmitted=false;
    let payload = {
      'processCode': this._processShellService.processCode,
      'sourceReference': this._processShellService.processId,
      'stageCode': this.stateCode
    }
    this._commonService.showSpinner();
    this.verifyotpService.resendOTP(payload).subscribe({
      next: (res)=>{
        this._commonService.hideSpinner();
       if(res?.body?.ErrorCode == "CBXRER037" && res.body.resendExceeded == "1"){
        // let _data: CBXDialogData = {
        //   icon: 'warning_grey',
        //   message: res.body.ErrorDescription,
        //   okLabel: 'Ok',
        // }
        let _data: CBXDialogData = {
          title: res.body.ErrorDescription
        }
        const dialogRef = this._dialog.open(ErrorAlertComponent, {
          data: _data,
          // panelClass: ['alert-dialog','alert-modal'],
          panelClass: ['error-alert-dialog'],
          backdropClass: 'confirmation-dialog-backdrop',
          hasBackdrop: true
        });
        dialogRef.afterClosed().subscribe(action => {
          if(this._commonService.getApplicationMode()=='RM') {
            // this._router.navigate(['rm-home']);
            this._processShellService.prepareARN(res.body);
            this.proceedNext(res);
          }
          else {
            if (res?.body.accessToken) {
              // res.refreshToken = res?.body.accessToken;
              this._userService.setToken(res.body);

              let decodesAccessToken = this._userService.decodeJwt(res?.body.accessToken);
              sessionStorage.setItem('customerName',decodesAccessToken.nickname);

              this._processShellService.prepareARN(res.body);
              this.proceedNext(res);
            }
          }
          });
       }
      },
      error: (error)=>{
        this._commonService.hideSpinner();
        if (error?.error?.ErrorCode == "ERROB015") {
          this._popupService.getModelInstance().close(error);
          this._dataStore.setData('error', 'rejected');
          this._router.navigateByUrl('onboarding/process-shell/rcob/result-info');
          return;
        }
        this.closeAlert('error');
        let _data: CBXDialogData = {
          // icon: 'warning',
          title: error.error.ErrorDescription,
          // message: 'Please try again later',
        }

        const dialogRef = this._dialog.open(ErrorAlertComponent, {
          data: _data,
          panelClass: ['error-alert-dialog'],
          backdropClass: 'confirmation-dialog-backdrop',
          hasBackdrop: true
        });
        dialogRef.afterClosed().subscribe(action => {
          if(this._commonService.getApplicationMode()=='RM') this._router.navigate(['rm-home']);
          else  this._commonService.exitApplication();
          });
      }
    });
    console.log("Resend OTP");
  }


  proceedNext(response:any = undefined){
    this._rocbService.checkResendAttempt = false;
    if(this.dialogData?.routingParams.openAsPopup == '1'){
      if(this._processShellService.checkAppStatus) {
        this.applicationStatusService.getApplicationStatus(this._processShellService.sourceRefNum).subscribe({
          next: (res) => {
            if(res) {
              this._processShellService.applicationStatus = res.applicationstatus;
              if(res.applicationstatus.status == 'DDE') {
                  let criteriaQuery = new CriteriaQuery();
                  this._applPendencyService.findAll(criteriaQuery)().subscribe(res=>{
                    if(res.data.length > 0) {
                        this._processShellService.stageCode = this._processShellService.processCode == 'CARDORG'?'ApplicantInfo':'SupplApplicantInfo'; 
                        this._processShellService.screenMode = 'rm-dde-mode'; 
                        this._popupService.getModelInstance().close(response);
                    }
                    else this._popupService.getModelInstance().close(response);
                  });
              } else this._popupService.getModelInstance().close(response);
            }
            else this._popupService.getModelInstance().close(response);
          }
        });
      }
      else this._popupService.getModelInstance().close(response);
    } else this._processShellService.triggerFormSubmittedCompleteStatus(this.state.payload);
  }

}
